module.exports = "/fonts/ARIALBI 1.woff?628a6951edc18f194f58b872cc9fe90a";